import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PostdCommonModule } from '../../../common/common.module';
import { FooterModule } from '../../core/navigation/footer/footer.module';
import { IntroCreatorsComponent } from './intro-creators.component';
import { RevenueCalculatorModule } from '../calculator/calculator.module';
import { ThumbnailModule } from '../../core/posts/thumbnail/thumbnail.module';
import { SharedDirectivesModule } from '../../../common/directives.module';

@NgModule({
  imports: [
    PostdCommonModule,
    SharedDirectivesModule,
    FooterModule,
    RevenueCalculatorModule,
    ThumbnailModule,
    RouterModule.forChild([
      {
        path: '',
        component: IntroCreatorsComponent,
      },
    ]),
  ],
  declarations: [IntroCreatorsComponent],
})
export class IntroCreatorsModule {}
